module["exports"] = [
  "###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/building_number.js
// module id = 1770
// module chunks = 0